<template>
	<div class="c-message">
		<b-toaster name="main-toaster"> </b-toaster>
	</div>
</template>

<script>
import {
	AlertCircleIcon,
	ZapOffIcon,
	ZapIcon,
	MinusIcon,
} from 'vue-feather-icons';
export default {
	components: {
		AlertCircleIcon,
		ZapOffIcon,
		ZapIcon,
		MinusIcon,
	},
	computed: {
		messageTrigger: function () {
			return this.$store.getters['message/updateTrigger'];
		},
		message: function () {
			return this.$store.getters['message/message'];
		},
	},
	watch: {
		messageTrigger: function () {
			this.showMessage(this.message);
		},
		eTrigger: function () {
			this.$nprogress.start();
			setTimeout(() => {
				this.$nprogress.done();
			}, 50);
		},
	},
	methods: {
		showMessage: function (message) {
			if (document.visibilityState === 'hidden') {
				return;
			}
			let icon = MinusIcon;
			const h = this.$createElement;
			if (message.type === 'warning') {
				icon = AlertCircleIcon;
			}
			if (message.type === 'failure') {
				icon = ZapOffIcon;
			}
			if (message.type === 'success') {
				icon = ZapIcon;
			}
			const vNodesTitle = h('div', { class: ['toast-message', message.type] }, [
				h(icon, { props: { size: '1.25x' } }),
				h('article', { class: '' }, message.message),
			]);
			this.$bvToast.toast(vNodesTitle, {
				noCloseButton: true,
				toaster: 'main-toaster',
				autoHideDelay: 4000,
			});
		},
	},
};
</script>

<style lang="scss">
.b-toaster.main-toaster {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 6666;

	.toast {
		position: relative;
		margin: 0 auto;
		margin-bottom: 1rem;
		width: 380px;
		max-width: initial;
		overflow: hidden;
		border-radius: 50px;
		background-color: var(--g4);
		border: none;
		text-align: left;
		font-family: $font-family-sans-serif;
		font-size: 14px;
		font-weight: 450;
		line-height: 1.3;
		color: rgba(255, 255, 255, 0.9);
		box-shadow: 0 0.7px 1.5px rgba(0, 0, 0, 0.107),
			0 2.2px 4.9px rgba(0, 0, 0, 0.123), 0 10px 22px rgba(0, 0, 0, 0.19);
		opacity: 1;

		&.fade:not(.show) {
			opacity: 0;
		}

		&:after {
			content: '';
			position: absolute;
			top: calc(50% - 12px);
			left: 4px;
			width: 24px;
			height: 24px;
			border-radius: 50%;
			background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALoSURBVHgB1ZhdUhpBEMf/PUAUgqn1ButDUpCXmBMETxB8SylVISfQnEC4gZ5AUoVW3jAnEE+gT2IqD9mcAMr4URVgO91LsEAFdpcv86uC3Z3Z2f1Pz3TP9BJCcPVyYxVRyhDjDchkmGARs6V1TNSQc4cAxwWfoMXV5I/DMwSE/N5Yt7PWYiK55TKycrmKQJDD3C424VaXL746vlr4uekmndtyiQpdq4SnIzB5cVgaeeewynrqg71A0X0GMpgo5Pzh5tow65lBFb9TuUzMxE4nL0ph+xlFTy9f5bIIIuw2tfnREI7HH7qhWJEIKvquxyofDKVaSkVhhohDrS1dlKu9ZX0W0zlliPYxY8QQFX13X1nvxTOKHev4Y/ZY6mS9BXfCrlIb+TmJ8lAnu0lvbnev74QRRXYwZxi0U7fznsN5wuZtrR6sWLyZ15OOxchsISyEBrP7KXF7taw/PdcyhMSA3nuPVW+QYPcTIWFy3ybP+xfpcUNOAq5tYhTJIjT87b4oRWMSM6oIyTVoXTpG7xASl2ngdka87AQh0e2UkQfYCAnBdTANDK1KoA8vbGowbCN/01yow2IZPFHMODFnmshQ0tMTRjiToeTAGcy0kXDRMC7wC0+MNuNEvfIIISCwE5F0bFB9FK3SGPO36m2tr1/n6kHDhi7Wo9Kwy3QuGwEqCIB2OFE7WPHChey5vwRpLKvFnp/c8EWtfCRTZQ8B6K6xnrAot3b9NtQeJWvlbb/3txaiBTn4djCDdrFzFOKSeDKzL6sRt9cQgOWzUsNwa93XfGMuxf8lwXeRv7kY2x7dmJy4z28PvXhtRsRLHYmutfqEac+4zUXMCZe52NvpvrUy+f1gN+hknQiEBx9aHiziSzKxxesCeek46Luen5cL98sf3V2I1+VnYTkVpe96rG7gtkctJ/FtanOOwZ8HiVKG7sckqSiIq6+ox2BSgiSA6keUZO3Ad+wciibF8mUxdEp2nc5VOon1f85fnZQrIfhBaVUAAAAASUVORK5CYII=');
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
		}
		&:focus {
			outline: none;
		}
		.toast-message {
			display: flex;
			align-items: center;

			svg {
				min-width: 24px;
				margin-right: 5px;
			}

			&.success {
				svg {
					color: $green;
				}
			}
			&.failure {
				svg {
					color: $red;
				}
			}
			&.warning {
				svg {
					color: $yellow;
				}
			}
		}
		.toast-header {
			padding: 6px 26px 0 38px;

			background-color: transparent;
			border-color: transparent;
			&:empty {
				padding: 0;
			}
			.close {
				display: none;
			}
		}
		.toast-body {
			min-height: 32px;
			padding: 7px 34px;
		}
	}
	.b-toast {
		margin: 0 auto;
		&.b-toaster-enter-active,
		&.b-toaster-leave-active,
		&.b-toaster-move {
			transition: transform 0.175s;
		}

		&.b-toaster-enter {
		}

		&.b-toaster-enter-to,
		&.b-toaster-enter-active {
			.toast.fade {
				// Delay the appearance of the toast until
				// the move transition has completed
				transition-delay: 0.175s;
			}
		}

		&.b-toaster-enter-to {
		}

		&.b-toaster-leave-active {
			position: absolute;
			transition-delay: 0.175s;

			.toast.fade {
				transition-delay: 0s;
			}
		}

		&.b-toaster-leave-to {
		}
	}

	@include media-breakpoint-down(xs) {
		.toast {
			width: auto;
		}
	}
}
</style>